import { useCallback, useMemo, useRef } from 'react'
import { useQuery } from '@apollo/client'

import { Label } from 'shared/__gql-types'

import { GetZonesDocument } from 'modulesCommon/graphql/queries/getZones.types'


export const useZone = () => {

  const regionNames = useRef(new Intl.DisplayNames(['en'], { type: 'region' }))

  const { data } = useQuery<{ getLabels: ReadonlyArray<Label> }>(GetZonesDocument)

  const byId = useMemo(
    () => (data?.getLabels ?? []).reduce<Record<string, Label>>((a, v) => ({ ...a, [v?.id ?? '']: v }), {}),
    [data?.getLabels],
  )

  const zoneOptions = useMemo(
    () => (data?.getLabels ?? []).map((label) => ({ value: label?.id ?? '' , label: label?.name ?? '' })),
    [data?.getLabels],
  )

  const getCountryOptions = useCallback(
    (id?: string) => {
      if (typeof id !== 'string') return []
      return (byId[id]?.country_codes ?? [])
        .reduce<Array<{ label: string, value: string }>>((a, value) => {
          if (typeof value !== 'string') return a
          const label = regionNames.current.of(value)
          if (typeof label !== 'string') return a
          return [...a, { label, value }]
        }, [])
    },
    [byId],
  )

  return {
    byId,
    zoneOptions,
    getCountryOptions,
  }
}
